var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-stars',_vm._b({attrs:{"active-color":"#ffdd00","inactive-color":"#999999","shadow-color":"#ffff00","hover-color":"#dddd00","char":"★","inactive-char":"","max":5,"value":Math.floor(_vm.current),"readonly":_vm.readonly},on:{"input":_vm.set}},'vue-stars',_vm.$attrs,false)),_vm._v("\n\t("+_vm._s(_vm.current)+")\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }